import { useMemo, useState } from 'react';
import { Control, useWatch } from 'react-hook-form';
import { HotelFormDataWithTranslations } from '@/i18n/translation-type-utils';
import PricingSummaryCalendar from '../benefits/PricingSummaryCalendar';

interface HotelPricingSummaryProps {
  control: Control<HotelFormDataWithTranslations>;
}

const HotelPricingSummary = ({ control }: HotelPricingSummaryProps) => {
  const hotelCategories = useWatch({ control, name: 'hotelRoomCategories' });

  const hotelCategoriesOptions = useMemo(
    () =>
      hotelCategories.map((category, index) => ({
        value: { name: category.name, index },
        label: category.name,
      })),
    [hotelCategories],
  );

  const [currentCategoryIndex, setCurrentCategoryIndex] = useState(0);
  const currentTarifs = useMemo(
    () => hotelCategories[currentCategoryIndex]?.tarifs ?? [],
    [currentCategoryIndex, hotelCategories],
  );

  return (
    <PricingSummaryCalendar
      tarifs={currentTarifs}
      categoryOptions={hotelCategoriesOptions}
      currentCategoryIndex={currentCategoryIndex}
      onCategoryChange={setCurrentCategoryIndex}
    />
  );
};

export default HotelPricingSummary;
